<template>
  <div>
        <el-carousel trigger="click" height="250px" :interval="3000" arrow="always" style="width:800px">
        <el-carousel-item v-for="item in imgList" :key="item.name">
          <img :src="item.src" style="height:100px;width:100px;" alt="图片丢失了" :title="item.title" />
        </el-carousel-item>
      </el-carousel>
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      imgList: [
        {
          name: "lj",
          src: require("@/assets/u1.png"),
          title: "这是lj.png"
        },
        {
          name: "logo",
          src: require("@/assets/u4.png"),
          title: "这是logo.png"
        },
        {
          name: "bg",
          src: require("@/assets/u2.png"),
          title: "这是bg.png"
        },
        {
          name: "sadmas",
          src: require("@/assets/u3.png"),
          title: "这是sadmas.png"
        }
      ]
    }
  },
 
}
</script>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue